import {
  getDetails,
  putResource,
  set,
  addOneNotification,
  setShowLoader,
  setHideLoader,
} from 'src/core/redux/actions';
import { PlateWell, PlateTemplate } from 'src/models';
import { state as stateConstants } from 'src/constants';
import { selectStateData } from 'src/core/redux/selectors';
import {
  updateReduxFileData
} from 'src/components/OligoDNA/components/UploadPlateTemplate/actions';
import { getErrorMessagesFromResponse, parseQueryParams } from 'src/utils';

import messages from './messages';

const getUrlData = (plateName, search) => {
  const queryParams = parseQueryParams(search);

  return {
    plateName,
    row: queryParams.row,
    column: queryParams.column,
  };
};

export const updateReduxPlateWellData = (data) => async (dispatch, getState) => {
  const templateData = selectStateData(
    PlateWell.NAME,
    stateConstants.IDENTIFIER_TYPE_DETAILS
  )(getState()) || {};

  dispatch(set(
    PlateWell.NAME,
    stateConstants.IDENTIFIER_TYPE_DETAILS,
    {
      ...templateData,
      data: {
        ...(templateData.data || {}),
        ...data,
      }
    }
  ));
};

export const updatePlateItemErrors = (
  plateName,
  setWellsError,
  errors = [],
) => (dispatch, getState) => {
  const templateData = selectStateData(
    PlateTemplate.NAME,
    stateConstants.IDENTIFIER_TYPE_ITEM
  )(getState()) || {};
  const plateStatuses = templateData?.data?.plateStatuses || [];
  const newPlateStatuses = plateStatuses.map((item) => ({
    ...item,
    errors: item.plateName === plateName ? errors : item.errors,
    isValid: item.plateName === plateName ? !errors.length : item.isValid,
  }));

  dispatch(updateReduxFileData({ plateStatuses: newPlateStatuses }));

  setWellsError(errors[0]);
};

export const fetchPlateWellDetails = (
  plateName,
  search,
  setWellsError,
  setIsInitialLoad,
) => async (dispatch, getState) => {
  const queryParams = parseQueryParams(search);

  dispatch(setShowLoader());

  const response = await dispatch(getDetails(PlateWell)({
    plateName,
    row: queryParams.row,
    column: queryParams.column,
  }));

  if (response.status !== 200) {
    dispatch(addOneNotification({
      type: 'error',
      message: messages.plateDetailsFetchError,
    }));

    dispatch(setHideLoader());

    return;
  }

  if (response.errors?.length) {
    const errors = await getErrorMessagesFromResponse(response);

    updatePlateItemErrors(plateName, setWellsError, [...errors])(dispatch, getState);
  }

  dispatch(setHideLoader());
  setIsInitialLoad?.(false);
};

export const updatePlateWell = (
  formState,
  plateName,
  search,
  setWellsError,
  setEnableActionButtons
) => async (dispatch, getState) => {
  const apiParams = getUrlData(plateName, search);
  const payload = PlateWell.processApiData(formState);
  const response = await dispatch(putResource(PlateWell)({ ...payload, ...apiParams }));

  if (response.status !== 200) {
    dispatch(addOneNotification({
      type: 'error',
      message: messages.plateWellEditFailure,
    }));

    await fetchPlateWellDetails(plateName, search, setWellsError)(dispatch);

    return;
  }

  if (response.errors?.length) {
    const errors = await getErrorMessagesFromResponse(response);

    updatePlateItemErrors(plateName, setWellsError, [...errors])(dispatch, getState);

    return;
  }

  dispatch(addOneNotification({
    type: 'success',
    message: messages.plateWellEditSuccess,
  }));

  updatePlateItemErrors(plateName, setWellsError, [])(dispatch, getState);
  setEnableActionButtons?.(false);

  const newPlateWellData = { status: 200, ...response };

  dispatch(updateReduxPlateWellData(newPlateWellData));
};
